(function () {
  'use strict';
  var node = document.getElementById('EliteCapsPackConfig');
  var dialog = document.getElementById('EliteCapsPackOffer');
  if (!node || !dialog || !dialog.showModal) return;
  var config;
  try { config = JSON.parse(node.textContent); } catch (error) { return; }
  var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || window.routes && window.routes.rootUrl || '/';
  var accept = dialog.querySelector('.ecp-accept');
  var status = dialog.querySelector('.ecp-status');
  var kicker = dialog.querySelector('.ecp-kicker');
  var copy = dialog.querySelector('#EcpCopy');
  var terms = dialog.querySelector('.ecp-terms');
  var selects = Array.prototype.slice.call(dialog.querySelectorAll('[data-ecp-select]'));
  var acceptText = accept.textContent;
  var DISMISS_KEY = 'ecpTimedDismissedV2';
  var addConfirmed = false;
  var trigger = null, checking = false, busy = false, source = 'cart', pending = false, suppressed = false;
  var entered = false, entryToken = 0, offerTimer = null, timedShown = false, timedTimer = null;
  var timedIndex = 0, timedDelays = [50000,150000], timedPriceShown = true;
  var visibleTime = 0, visibleSince = document.hidden ? null : Date.now(), pageActive = true;

  function cancelOfferTimer() { if (offerTimer !== null) { clearTimeout(offerTimer); offerTimer = null; } }
  function cartIsVisible() {
    var mini = document.querySelector('.mini-cart');
    return config.cartPage || !!(mini && mini.getAttribute('aria-hidden') === 'false');
  }
  function suppress() { cancelOfferTimer(); suppressed = true; pending = false; }
  function requestOffer() { if (!suppressed) pending = true; }
  function dismissedThisSession() { try { return sessionStorage.getItem(DISMISS_KEY) === '1'; } catch (error) { return false; } }
  function rememberDismissal() { try { sessionStorage.setItem(DISMISS_KEY, '1'); } catch (error) {} }
  function isGift(item) { return item.properties && item.properties._EliteGift === '1'; }
  function paidItems(cart) { return cart.items.filter(function (item) { return !isGift(item); }); }

  async function request(path, data) {
    var options = { credentials: 'same-origin', cache: 'no-store' };
    if (data) {
      options.method = 'POST';
      options.headers = { 'Content-Type': 'application/json' };
      options.body = JSON.stringify(data);
    }
    var response = await fetch(root + path, options);
    var result = await response.json();
    if (!response.ok) throw new Error(result.description || result.message || 'No se pudo actualizar tu carrito. Vuelve a intentarlo.');
    return result;
  }
  function readCart() { return request('cart.js'); }
  var cartTouched = false;
  ['cart:updated', 'cart:change', 'cart:refresh', 'cart:rerendered', 'product:added'].forEach(function (name) {
    document.addEventListener(name, function () { cartTouched = true; }, true);
  });
  document.addEventListener('submit', function (event) {
    if (event.target.matches && event.target.matches('form[action*="/cart/add"]')) cartTouched = true;
  }, true);
  // The server already told us the cart was empty; skip the slow /cart.js round trip until it changes
  function cartForOffer() {
    return config.cartItemCount === 0 && !cartTouched ? Promise.resolve({ items: [], currency: 'USD' }) : readCart();
  }

  function capItem(cart) {
    return paidItems(cart).find(function (item) {
      return item.product_id === config.capProductId && !item.selling_plan_allocation && !(item.properties && item.properties._EliteAddon === '1');
    }) || null;
  }
  function eligible(cart) {if(window.EliteSitewide25&&window.EliteSitewide25.isActive())return false;
    if (cart.currency !== 'USD') return false;
    return !cart.items.some(function (item) {
      return item.product_id === config.packProductId || item.properties && item.properties._EliteCapPack;
    });
  }

  function pageVariantId() {
    var input = document.querySelector('main form[action*="/cart/add"] [name="id"]');
    var value = Number(input && input.value);
    return value || null;
  }
  function setThumb(select) {
    var option = select.options[select.selectedIndex];
    var thumb = select.closest('.ecp-pick').querySelector('.ecp-thumb');
    var image = option && option.getAttribute('data-image');
    if (thumb && image) { thumb.src = image; thumb.alt = option.getAttribute('data-title') || ''; }
  }
  function preselect(first) {
    var options = Array.prototype.slice.call(selects[0].options);
    var initial = options.find(function (option) { return Number(option.value) === first; }) || options[0];
    var black = options.find(function (option) { return (option.getAttribute('data-title') || '').trim().toLowerCase() === 'black'; });
    var armyGreen = options.find(function (option) { return (option.getAttribute('data-title') || '').trim().toLowerCase() === 'army green'; });
    var preferred = [initial, black, armyGreen];
    var start = Math.max(0, options.indexOf(initial));
    selects.forEach(function (select, index) {
      var pick = preferred[index] || options[(start + index) % options.length];
      if (pick) select.value = pick.value;
      setThumb(select);
    });
  }

  function close(remember) {
    if (busy) return;
    if (dialog.open) dialog.close();
    if (remember && source === 'timed') rememberDismissal();
    var mini = document.querySelector('.mini-cart[aria-hidden="false"]');
    var focus = mini ? trigger && mini.contains(trigger) ? trigger : mini.querySelector('button, a[href], input') : trigger;
    if (focus && focus.isConnected) focus.focus({ preventScroll: true });
    source = 'cart';
  }

  function renderOffer(cart, timed) {
    source = timed ? 'timed' : 'cart';
    trigger = document.activeElement;
    var paid = paidItems(cart);
    var original = capItem(cart);
    preselect(original ? original.variant_id : pageVariantId());
    if (original) {
      kicker.textContent = 'COMPRA 2 Y RECIBE 1 GRATIS';
      copy.textContent = 'Tu Ridgeline pasa a ser la gorra 1. Agrega otras dos: pagas 2 gorras y la 3.ª va por nuestra cuenta.';
      terms.textContent = 'El paquete de 3 gorras sustituye una Ridgeline individual en tu carrito.';
      terms.hidden = false;
    } else {
      kicker.textContent = 'COMPRA 2 Y RECIBE 1 GRATIS';
      copy.textContent = 'Paga 2 y recibe la tercera gorra gratis. Elige el color de cada una.';
      terms.textContent = '';
      terms.hidden = true;
    }
    status.hidden = true;
    accept.disabled = false;
    accept.textContent = acceptText;
    dialog.showModal();
    addConfirmed = false;
    suppress();
    accept.focus();
  }

  function otherPopupOpen() {
    return !!document.querySelector('dialog[open], .egp-open, .modal[aria-hidden="false"]');
  }
  function busyElsewhere() {
    return window.EliteCartPromotions && window.EliteCartPromotions.busy || window.__eliteTitaniumUpgradeBusy || window.__eliteCapsPackBusy;
  }

  // ----- Cart trigger: shown a moment after a Ridgeline lands in the cart -----
  function scheduleOffer() {
    if (dialog.open) return;
    if (!cartIsVisible() && !addConfirmed) {
      cancelOfferTimer();
      if (entered) { entered = false; pending = false; suppressed = false; entryToken++; close(false); }
      return;
    }
    if (!entered) { entered = true; pending = true; suppressed = false; entryToken++; }
    if (dialog.open) return;
    if (suppressed || !pending || offerTimer !== null) return;
    offerTimer = setTimeout(function () {
      offerTimer = null;
      if ((cartIsVisible() || addConfirmed) && !suppressed && pending) offerFromCart();
    }, 5000);
  }
  async function offerFromCart() {
    if (checking || busy || busyElsewhere()) { scheduleOffer(); return; }
    checking = true;
    var token = entryToken;
    try {
      var cart = await readCart();
      if (token !== entryToken || (!cartIsVisible() && !addConfirmed)) return;
      var paid = paidItems(cart);
      if (!eligible(cart) || !capItem(cart)) { addConfirmed = false; suppress(); return; }
      if (dialog.open || suppressed || !pending) return;
      if (otherPopupOpen()) { scheduleOffer(); return; }
      renderOffer(cart, false);
    } catch (error) {} finally { checking = false; }
  }

  // ----- Product page trigger: price scrolled out of view, or about a minute on the page -----
  function accountVisibleTime() {
    var now = Date.now();
    if (visibleSince !== null) visibleTime += Math.max(0, now - visibleSince);
    visibleSince = document.hidden ? null : now;
  }
  function priceScrolledAway() {
    var price = document.getElementById('evolution-price-list');
    if (!price || window.scrollY <= 0) return false;
    var bounds = price.getBoundingClientRect();
    var offset = 0;
    return bounds.height > 0 && bounds.bottom <= -offset;
  }
  async function offerTimed(reason) {
    reason = reason || 'price';
    if (!pageActive || checking || busy || document.hidden || cartIsVisible() || otherPopupOpen() || busyElsewhere()) return;
    if (reason === 'price' && timedPriceShown || reason === 'time' && (timedIndex >= timedDelays.length || visibleTime < timedDelays[timedIndex])) return;
    checking = true;
    try {
      var cart = await cartForOffer();
      if (!pageActive || document.hidden || cartIsVisible() || otherPopupOpen()) return;
      if (!eligible(cart)) {
        if (reason === 'price') timedPriceShown = true;
        else while (timedIndex < timedDelays.length && visibleTime >= timedDelays[timedIndex]) timedIndex++;
        return;
      }
      renderOffer(cart, true);
      if (reason === 'price') timedPriceShown = true;
      else while (timedIndex < timedDelays.length && visibleTime >= timedDelays[timedIndex]) timedIndex++;
    } catch (error) {} finally { checking = false; }
  }
  function timedTick() {
    timedTimer = null;
    accountVisibleTime();
    if (dialog.open) { while (timedIndex < timedDelays.length && visibleTime >= timedDelays[timedIndex]) timedIndex++; }
    
    else if (timedIndex < timedDelays.length && visibleTime >= timedDelays[timedIndex]) offerTimed('time');
    if (config.productMode && (!timedPriceShown || timedIndex < timedDelays.length) && !document.hidden) timedTimer = setTimeout(timedTick, 1000);
  }
  function startTimed() {
    if (!config.productMode || timedTimer !== null || document.hidden || timedPriceShown && timedIndex >= timedDelays.length) return;
    visibleSince = Date.now();
    timedTimer = setTimeout(timedTick, 1000);
  }

  async function rollback(transaction) {
    var cart = await readCart();
    var added = cart.items.filter(function (item) { return item.properties && item.properties._EliteCapPack === transaction; });
    for (var item of added) await request('cart/change.js', { id: item.key, quantity: 0 });
  }

  accept.addEventListener('click', async function () {
    if (busy) return;
    busy = true;
    window.__eliteCapsPackBusy = true;
    accept.disabled = true;
    accept.textContent = 'Agregando tu paquete…';
    status.hidden = true;
    var transaction = 'ecp-' + Date.now() + '-' + Math.random().toString(36).slice(2, 9);
    var attempted = false;
    try {
      var cart = await readCart();
      if (!eligible(cart)) { busy = false; close(false); return; }
      var paid = paidItems(cart);
      var original = capItem(cart);
      var properties = { _EliteCapPack: transaction };
      selects.forEach(function (select, index) {
        properties['Color de la gorra ' + (index + 1)] = select.options[select.selectedIndex].getAttribute('data-title');
      });
      attempted = true;
      await request('cart/add.js', { items: [{ id: config.packVariantId, quantity: 1, properties: properties }] });
      cart = await readCart();
      var added = cart.items.find(function (item) { return item.properties && item.properties._EliteCapPack === transaction; });
      if (!added || added.quantity !== 1) throw new Error('No se pudo agregar tu paquete de 3 gorras. Vuelve a intentarlo.');
      if (original && cart.items.some(function (item) { return item.key === original.key; })) {
        await request('cart/change.js', { id: original.key, quantity: original.quantity - 1 });
      }
      // Stay on the same page: close the offer and show the updated cart in the floating drawer instead of navigating to /cart
      addConfirmed = false;
      if (dialog.open) dialog.close();
      source = 'cart';
      if (config.cartPage) { window.location.reload(); return; }
      var drawerCart = document.querySelector('.mini-cart');
      if (window.theme && window.theme.cartType === 'drawer' && drawerCart) {
        var drawerOpen = drawerCart.getAttribute('aria-hidden') === 'false';
        document.documentElement.dispatchEvent(drawerOpen
          ? new CustomEvent('cart:refresh', { bubbles: true, detail: { scrollToTop: false } })
          : new CustomEvent('product:added', { bubbles: true, detail: { quantity: 1, eliteOfferAccepted: true } }));
      } else {
        window.location.assign(root + 'cart');
      }
    } catch (error) {
      var message = error.message;
      if (attempted) {
        try { await rollback(transaction); } catch (restoreError) { message += ' Revisa tu carrito antes de finalizar la compra.'; }
      }
      status.textContent = message;
      status.hidden = false;
      accept.disabled = false;
      accept.textContent = acceptText;
    } finally {
      busy = false;
      window.__eliteCapsPackBusy = false;
    }
  });

  selects.forEach(function (select) { select.addEventListener('change', function () { setThumb(select); }); });
  dialog.querySelector('.ecp-close').addEventListener('click', function () { close(true); });
  dialog.querySelector('.ecp-decline').addEventListener('click', function () { close(true); });
  dialog.addEventListener('cancel', function (event) { event.preventDefault(); event.stopPropagation(); close(true); });
  dialog.addEventListener('click', function (event) {
    event.stopPropagation();
    if (event.target !== dialog) return;
    var box = dialog.getBoundingClientRect();
    if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) close(true);
  });
  ['pointerdown', 'mousedown', 'touchstart', 'keydown', 'keyup', 'focusin'].forEach(function (name) {
    dialog.addEventListener(name, function (event) { event.stopPropagation(); });
  });

  function addIntent(form) {
    if (!form) return;
    suppressed = false;
    requestOffer();
  }
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (form.matches && form.matches('form[action*="/cart/add"]')) addIntent(form);
  }, true);
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target.closest || dialog.contains(target)) return;
    var change = target.closest('[data-action="decrease-quantity"], [data-action="increase-quantity"], a[href*="/cart/change"]');
    if (change) { suppress(); close(false); return; }
    var button = target.closest('.product-form__add-button, .botaocmprar, .botaoaddcarrinho-qtd');
    if (button) addIntent(button.closest('form[action*="/cart/add"], .product-form'));
  }, true);
  document.addEventListener('change', function (event) {
    if (event.target.closest && event.target.closest('.mini-cart, [data-section-type="cart"]')) { suppress(); close(false); }
  }, true);
  document.addEventListener('product:added', function (event) {
    if (event && event.detail && event.detail.eliteOfferAccepted) return;
    addConfirmed = true;
    suppressed = false;
    requestOffer();
    scheduleOffer();
  });
  function watchMiniCart() {
    var mini = document.querySelector('.mini-cart');
    if (!mini) return;
    new MutationObserver(scheduleOffer).observe(mini, { attributes: true, attributeFilter: ['aria-hidden'], childList: true, subtree: true });
    if (mini.getAttribute('aria-hidden') === 'false') scheduleOffer();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchMiniCart, { once: true }); else watchMiniCart();
  ['cart:updated', 'cart:change', 'cart:refresh', 'cart:rerendered'].forEach(function (name) { document.addEventListener(name, scheduleOffer); });
  if (config.cartPage) { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scheduleOffer, { once: true }); else scheduleOffer(); }
  // Loaded async: start right away and react to the scroll itself, not only to the 1s tick
  startTimed();
  window.addEventListener('scroll', function () {
    if (false) offerTimed();
  }, { passive: true });
  document.addEventListener('visibilitychange', function () {
    if (!config.productMode) return;
    accountVisibleTime();
    if (timedTimer !== null) { clearTimeout(timedTimer); timedTimer = null; }
    startTimed();
  });
  window.addEventListener('pagehide', function () {
    pageActive = false;
    cancelOfferTimer();
    accountVisibleTime();
    visibleSince = null;
    if (timedTimer !== null) { clearTimeout(timedTimer); timedTimer = null; }
    entered = false; pending = false; entryToken++;
    close(false);
  });
  window.addEventListener('pageshow', function (event) { pageActive = true; if (event.persisted) { scheduleOffer(); startTimed(); } });
}());



